import { Button, HStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { Spacer } from 'native-base';
import React from 'react';

interface FooterProps {
  handleFollowTicket: () => void;
  handleNewTicket: () => void;
}

export const Footer: React.FC<FooterProps> = ({ handleFollowTicket, handleNewTicket }) => {
  const isDesktop = useBreakpointValue({ sm: false, lg: true });

  return (
    <HStack
      py={Spacing['inline.xxs']}
      w="full"
      bg={{ base: 'white', lg: 'transparent' }}
      alignItems="center"
      borderTopWidth={{ base: 1, lg: 0 }}
      borderTopColor={Color['neutral.lightest']}
      justifyContent="space-between">
      {isDesktop && <Spacer />}
      <HStack
        space={Spacing['inline.xxxs']}
        {...(!isDesktop && {
          width: 'full',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: Spacing['inline.xxxs'],
        })}>
        <Button
          onPress={handleFollowTicket}
          _text={{ fontWeight: Typography['fontweight.semibold'] }}
          variant="secondary">
          Acompanhar
        </Button>
        <Button
          onPress={handleNewTicket}
          _text={{ fontWeight: Typography['fontweight.semibold'] }}
          variant={'primary'}>
          Nova boleta
        </Button>
      </HStack>
    </HStack>
  );
};
